export default __webpack_public_path__ + "static/media/grafosHelp.675fcd54.md";